<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 188px;
  margin-top: 20px;

  .plane {
    // padding-top: 5px;

    .env {
      width: 100%;
      height: 102px;
      padding: 0 20px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .env_top {
        width: 177px;
        display: flex;
        height: 41px;
        .no {
          height: 40px;
          line-height: 55px;
          font-size: 18px;
          width: 54px;
        }

        .env_numb {
          font-family: 'dina';
          font-size: 36px;
          width: 63px;
          text-align: right;
          
        }
        .env_company {
            font-family: 'dina';
            width: 52px;
            height: 18px;
            line-height: 18px;
            font-size: 16px;
            margin-top: 18px;
            margin-left: 8px;
            color: #C4C4C4;
            position: relative;
            img{
              width: 10px;
              height: 10px;
              position: absolute;
              top: -10px;
              left: 0;
            }
          }
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane title="环境监测" class="plane"
      :iconImg="require('@/assets/compImg/icon/env.png')">
      <div class="env">
        <div class="env_top" v-for="(item,index) in envList" :key="index">
          <div class="no">{{item.no}}</div>
          <div class="env_numb" :class="item.alarm==1?'error-color':''">{{Number(item.env_numb).toFixed(2)}}</div>
          <span class="env_company">{{item.env_company}} <img src="@/assets/compImg/icon/Triangular1.png" alt=""></span>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
  props:{
    envList:Array
  }
}
</script>
